<ng-container [formGroup]="addressForm">
  @if (!showManualInput()) {
    <rma-address-autocomplete
      [value]="value"
      [label]="label()"
      [required]="required()"
      [disable]="disabled()"
      [prefix]="prefix()"
      [hideHint]="hideHint()"
      [placeholder]="placeholder()"
      [autoFocus]="autoFocus()"
      formControlName="searchInput"
    />
    @if (error()) {
      <mat-error>{{ error() }}</mat-error>
    }
    @if (!hideManualEntry()) {
      <button
        type="button"
        class="my-3"
        [class.hidden]="disabled()"
        (click)="onShowManualInput(required(), true)"
        mat-stroked-button
        color="primary"
      >
        <span class="text-sm">{{ 'form.action.manually-enter-address' | transloco }}</span>
      </button>
    }
  } @else {
    <div class="flex flex-col" formGroupName="manualInput">
      <h3 class="mat-subtitle-1">{{ 'form.label.manually-enter-address' | transloco }}</h3>
      <div class="flex flex-wrap items-center gap-x-4 *:flex-[1_1_0]">
        <mat-form-field>
          <mat-label>{{ 'form.label.unit-number' | transloco }}</mat-label>
          <input type="text" matInput formControlName="unitNumber" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'form.label.street-number' | transloco }}</mat-label>
          <input type="text" [required]="required()" matInput formControlName="streetNumber" />
          <mat-error />
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>{{ 'form.label.street-name' | transloco }}</mat-label>
        <input
          type="text"
          [placeholder]="'form.placeholder.street-name' | transloco"
          [required]="required()"
          matInput
          formControlName="street"
          autocomplete="address-line1"
        />
        <mat-error />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'form.label.locality' | transloco }}</mat-label>
        @if (prefix()) {
          <rma-icon class="mr-2" glyph="place" matPrefix />
        }
        <input
          type="text"
          [matAutocomplete]="auto"
          [placeholder]="'form.placeholder.locality-search' | transloco"
          [required]="required()"
          formControlName="locality"
          matInput
          autocomplete="address-level2"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          @for (option of options$ | async; track option) {
            <mat-option [value]="option">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <div class="mb-4">
        <button type="button" (click)="onShowManualInput(required(), false)" mat-button>
          <rma-icon glyph="arrow_back" />
          <span>{{ 'form.action.search-address' | transloco }}</span>
        </button>
      </div>
    </div>
  }
</ng-container>
